import { Component, inject, LOCALE_ID } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-authentication-layout",
  templateUrl: "./authentication-layout.component.html",
  styleUrls: ["./authentication-layout.component.scss"],
  animations: [],
  imports: [RouterOutlet],
})
export class AuthenticationLayoutComponent {
  lang = inject(LOCALE_ID);
}
